export default __webpack_public_path__ + "static/media/PattroBranca.204eda0c.svg";